var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoOverlayPhoneDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3664 25.4166L28.1664 24.9333C27.1497 24.8166 26.1497 25.1666 25.4331 25.8833L22.3497 28.9666C19.9847 27.7666 17.8397 26.2016 15.9864 24.3466C14.1314 22.4933 12.5664 20.3483 11.3664 17.9833L14.4497 14.8999C15.1664 14.1833 15.5164 13.1833 15.3997 12.1666L14.9164 7.9666C14.7164 6.28327 13.2997 5.0166 11.5997 5.0166H8.71641C6.83308 5.0166 5.26641 6.58327 5.38308 8.4666C5.82474 15.5816 8.88974 21.9799 13.6214 26.7116C18.3531 31.4433 24.7514 34.5083 31.8664 34.9499C33.7497 35.0666 35.3164 33.4999 35.3164 31.6166V28.7333C35.3164 27.0333 34.0497 25.6166 32.3664 25.4166Z",
    fill: "url(#paint0_linear_181252_183664)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_181252_183664",
    x1: 20.3467,
    y1: 5.0166,
    x2: 20.3467,
    y2: 21.8575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoOverlayPhoneDark);
export default __webpack_public_path__ + "static/media/video-overlay-phone-dark.25bfd61927b940cd007b31d691341a91.svg";
export { ForwardRef as ReactComponent };